var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPackageIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.615 8.664c.07 0 .105 0 .14.035l6.926 4.114v7.874a.593.593 0 0 1-.597.598.56.56 0 0 1-.281-.105l-5.344-3.235c-.668-.422-1.09-1.195-1.09-2.039v-6.96c0-.176.105-.282.246-.282m14.73-1.266c0 .106-.07.176-.14.247l-6.961 4.148-6.996-4.148c-.07-.07-.14-.176-.14-.247 0-.105.07-.21.14-.28l5.8-3.516c.387-.211.774-.352 1.196-.352.387 0 .773.14 1.125.352l5.8 3.515c.106.07.177.176.177.281Zm.493 1.266c.14 0 .28.106.28.281v6.961a2.44 2.44 0 0 1-1.124 2.04L13.65 21.18c-.105.07-.21.07-.281.07a.555.555 0 0 1-.563-.563v-7.875L19.697 8.7c.035-.035.07-.035.14-.035Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPackageIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/package-icon.94bababd46b48d2f4219c4aa059392a4.svg";